// extracted by mini-css-extract-plugin
export default {"container":"aH7cr","errorTitle":"q0mJy","textContainer":"DSO5e"};